// rsaUtils.js
import JSEncrypt from 'jsencrypt';
// 仅保留 RSA 公钥；加密材料不得包含私钥参数。
const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9RKQmhSyqoKMc/gHzci5UrHCU9uKNItL/Lho3gn3AJa9WifZGDwp0k1aDeQmpupRZPHRmHOuV1GCOuv8D9qZYomWWyyUm+ioxR6sRPlNuCRpBxwbKdNugcuBhH1XAdXRSS6bt5Au4+Vbo+NGs2PElSf0ySb7uL+YpUDbn6C6AKKoHitJfOTQUgJG1Dh5+sjhDayYJlFYflKGTcSrz/V+glC4qIXjj6zKNMjPsSHPKLsCZ05Dd9eQE/SRrP+Tq6OLG6kyx+GzAn2bbopdreBTO7Tpuahy1RjLtJP3TYdBu1mazeWgJ7KGTB90zK4tqlBLMWqAq55V0qK39gXGPPmMSwIDAQAB';
/**
 * RSA 加密
 * @param {string} plainText - 明文
 * @param {string} publicKey - 公钥（PEM 格式）
 * @returns {string} - 加密后的 Base64 字符串
 */
export function encrypt(plainText:any) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(plainText);
}


// 获取当前时间并格式化为 yyyy-MM-dd hh:23:34:39
export function getCurrentTimestamp(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = '23'; // 固定分钟为23
  const seconds = '34'; // 固定秒为34
  const millisecond = '39'; // 固定秒为34
  return `${year}${month}${day}${hours}${minutes}${seconds}${millisecond}`;
}
export function insertAtPosition(str: string, insert: string, position: number) {
  if (position > str.length) position = str.length;
  if (position < 0) position = 0;
  return str.slice(0, position) + insert + str.slice(position);
}

// 生成32位随机字符串
export function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}